import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ParseErrorClass;
function ParseError() {
  if (ParseErrorClass === VOID) {
    class $ {
      constructor(position, message) {
        this.position_1 = position;
        this.message_1 = message;
      }
    }
    initMetadataForClass($, 'ParseError');
    ParseErrorClass = $;
  }
  return ParseErrorClass;
}
function _ParseResult___init__impl__gvz3cn(value) {
  return value;
}
function _ParseResult___get_value__impl__86mnxf($this) {
  return $this;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      Ok_6vkbj8_k$(indexOfNextUnparsed) {
        return _ParseResult___init__impl__gvz3cn(indexOfNextUnparsed);
      }
      Error_ca056s_k$(position, message) {
        return _ParseResult___init__impl__gvz3cn(new (ParseError())(position, message));
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  _ParseResult___get_value__impl__86mnxf as _ParseResult___get_value__impl__86mnxf3azxkbb11grfu,
  Companion_instance as Companion_instances6yiyh4o0b70,
  ParseError as ParseError1ji8h7fh6q5w9,
};
//endregion

//# sourceMappingURL=ParseResult.mjs.map
